import styled from 'styled-components';

export const StaffManagementWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;
